// src/LoginPage.js
import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useStore } from "./store";
import { loginSuccess } from "./store";
import { API_BASE_URL } from "./settings";

export default function LoginPage() {
  const navigate = useNavigate();
  const { dispatch } = useStore();

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/current-user/`, { withCredentials: true })
      .then((response) => {
        dispatch(loginSuccess(response.data));
        navigate("/scan", { replace: true });
      })
      .catch((err) => {
        console.log("Not logged in, redirecting to login page.");
        if (err.response && err.response.status === 401) {
          console.log("coming here");
          window.location.href = `${API_BASE_URL}/api/login/`;
        }else {
          console.log("Error fetching current user:", err);
          navigate("/scan/error/", { replace: true });
        }
        console.log("outsied if");
      });
  }, [dispatch, navigate]);

  return (
    <div className="login-container">
      <h2>Redirecting to login...</h2>
    </div>
  );
}
